import { Component } from '@angular/core';
import { PageContent } from '../../shared/page-content/page-content.component';
import { ProjectCard } from './project-card/project-card.component';

type ProjectItem = {
  client: string;
  service: string;
  description: string;
  url: string;
};

@Component({
  selector: 'app-projects',
  imports: [PageContent, ProjectCard],
  templateUrl: './projects.component.html',
  styleUrl: './projects.component.scss',
})
export class Projects {
  projectItems: ProjectItem[] = [
    {
      client: 'Sheffield Drive Church of Christ',
      service: 'Business website',
      description: 'A website for Sheffield Drive Church of Christ to connect with their congregation and welcome visitors.',
      url: 'https://sheffielddrivecoc.org/',
    },
  ];
}
